import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  MenuWorkspace,
  type MenuWorkspaceProps,
} from "@/features/staff/menu-workspace"

export default function StaffLocationManageMenuIndex(props: MenuWorkspaceProps) {
  return (
    <StaffLayout>
      <MenuWorkspace {...props} />
    </StaffLayout>
  )
}
